'use client'

import { Common } from '@/config/NextImport'
import { useEffect, useState } from 'react'

const DiamondDetailSummry = ({ productDetail, productOptions }: any) => {
  const [MarginValue, setMarginLeft] = useState<any>(0)

  const setBlockMarginLeft = () => {
    const carat = productOptions.filter((x: any) => x.title.toLowerCase() === 'carat')[0].value
    const totalWidth: number = 90
    const ranges = [0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1, 1.125, 1.25, 1.375, 1.5, 1.625]
    const blocks: number = 12
    const widthPercent: number = Number((totalWidth / blocks).toFixed(2))
    let marginLeft: any = -1
    let lastValue = ranges[ranges.length - 1]
    if (carat >= lastValue) {
      marginLeft = totalWidth
    } else if (carat <= ranges[0]) {
      marginLeft = 0
    } else {
      for (const key in ranges) {
        if (marginLeft === -1) {
          if (carat <= ranges[key]) {
            lastValue = ranges[parseInt(key) - 1]
            let keyIndex: any = -1
            for (let i = 1; i <= 6; i++) {
              if (carat >= lastValue) {
                keyIndex++
              }
              lastValue = lastValue + 0.025
            }
            const blockPercent = (widthPercent / 6) * (parseInt(keyIndex) + 1)
            if (carat < 1) {
              marginLeft =
                widthPercent * (parseInt(key) - 1) + blockPercent + (parseInt(key) + 1) * 0.5
            } else {
              marginLeft =
                widthPercent * (parseInt(key) - 1) + blockPercent + (parseInt(key) + 1) * 0.35
            }
          }
        }
      }
    }
    setMarginLeft(parseFloat(marginLeft).toFixed(2))
  }

  useEffect(() => {
    setBlockMarginLeft()
  }, [productDetail])

  return (
    <div className="product-detail-bottom">
      <div className="row">
        <div className="col-lg-5">
          <div className="product-detail-left diamond-tabs">
            <div
              className="accordion"
              id="Diamond-Detailtab"
            >
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="headingOne"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#diamond-tab1"
                    aria-expanded="true"
                    aria-controls="diamond-tab1"
                  >
                    {productDetail.is_gemstone ? 'Gemstone Details' : 'Diamond Details'}
                  </button>
                </h2>
                <div
                  id="diamond-tab1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body p-0">
                    <table className="table striped">
                      <tbody>
                        <tr>
                          <td>SKU</td>
                          <td>{productDetail.sku}</td>
                        </tr>
                        {Common.GetJSON(productDetail.attribute_options).map(function (item: any) {
                          if (item.value !== '' && item.value !== null) {
                            return (
                              <tr key={Math.random()}>
                                <td>{item.title}</td>
                                <td>
                                  {item.title.toLowerCase() === 'certificate' &&
                                  productDetail.diamond_certificate_pdf !== '' &&
                                  productDetail.diamond_certificate_pdf !== null ? (
                                    <a
                                      className="p-0"
                                      href={productDetail.diamond_certificate_pdf}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {item.value}
                                    </a>
                                  ) : (
                                    <>{item.value}</>
                                  )}
                                </td>
                                {/* <td>{item.value} </td> */}
                              </tr>
                            )
                          }
                          return true
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <div className="product-detail-right">
            <div className="shape-detail-tabs">
              {productOptions !== undefined &&
              productOptions.filter((x: any) => x.title === 'Shape')[0]?.value.toLowerCase() ===
                'round' ? (
                <h3>The Four C’s Of Your {productDetail.is_gemstone ? 'Gemstone' : 'Diamond'}</h3>
              ) : (
                <h3>The Three C’s Of Your {productDetail.is_gemstone ? 'Gemstone' : 'Diamond'}</h3>
              )}
              <div
                className="accordion"
                id="shape-detail-accordian"
              >
                <div className="accordion-item carat-grade-item">
                  <div
                    className="accordion-header"
                    id="diamondshape-tab1"
                  >
                    <button
                      className="accordion-button  collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      Carat :{' '}
                      {
                        productOptions.filter(
                          (item: any) => item.title.toLowerCase() === 'carat'
                        )[0].value
                      }{' '}
                      ct.
                    </button>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="diamondshape-tab1"
                    data-bs-parent="#shape-detail-accordian"
                  >
                    <div className="accordion-body">
                      <div className="carat-grade-section">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="color-grade-detail">
                              <p>
                                A {productDetail.is_gemstone ? 'Colorstone' : 'Diamond'}’s carat weight is directly related to its size, but it’s
                                important to note that much of the original weight is lost during
                                the cutting and polishing process—as much as two-thirds in some
                                cases. Larger, high-quality rough {productDetail.is_gemstone ? 'colorstones' : 'diamonds'} are significantly rarer
                                than smaller ones, which makes them more valuable. As a result, a
                                single 2-carat {productDetail.is_gemstone ? 'colorstone' : 'diamond'} of the same quality will typically be more
                                expensive than two separate 1-carat {productDetail.is_gemstone ? 'colorstones' : 'diamonds'}.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="carat-grade-left">
                              <div className="carat-grade-img">
                                <img
                                  src={Common.setImagePath(
                                    'assets/images/tooltips/carat/carat_' +
                                      (productDetail.is_gemstone ? 'gemstone' : 'diamond') +
                                      '_0_25.png'
                                  )}
                                  alt="carat"
                                />
                              </div>
                              <ul
                                className="carat-grade-list"
                                // ref={ulBlock}
                                id="caratBlock"
                              >
                                <li
                                  data-number={
                                    (productDetail.is_gemstone ? 'gemstone' : 'diamond') + '_0_25'
                                  }
                                  className={'grade-list-btn '}
                                >
                                  <span className="grade-list-label">.25</span>
                                </li>
                                <li
                                  data-number={
                                    (productDetail.is_gemstone ? 'gemstone' : 'diamond') + '_0_50'
                                  }
                                  className={'grade-list-btn '}
                                >
                                  <span className="grade-list-label">.50</span>
                                </li>
                                <li
                                  data-number={
                                    (productDetail.is_gemstone ? 'gemstone' : 'diamond') + '_0_75'
                                  }
                                  className={'grade-list-btn '}
                                >
                                  <span className="grade-list-label">.75</span>
                                </li>
                                <li
                                  data-number={
                                    (productDetail.is_gemstone ? 'gemstone' : 'diamond') + '_1_00'
                                  }
                                  className={'grade-list-btn '}
                                >
                                  <span className="grade-list-label">1.00</span>
                                </li>
                                <li
                                  data-number={
                                    (productDetail.is_gemstone ? 'gemstone' : 'diamond') + '_1_25'
                                  }
                                  className={'grade-list-btn '}
                                >
                                  <span className="grade-list-label">1.25</span>
                                </li>
                                <li
                                  data-number={
                                    (productDetail.is_gemstone ? 'gemstone' : 'diamond') + '_1_50'
                                  }
                                  className={'grade-list-btn '}
                                >
                                  <span className="grade-list-label">1.5+</span>
                                </li>
                              </ul>
                              <div
                                className="carat-grade-list-tooltip"
                                style={{
                                  marginLeft: MarginValue + '%',
                                  width: '3%'
                                }}
                              >
                                <div className="carat-tooltip-box">
                                  <span className="tooltip-arrow-top"></span>
                                  <span>
                                    Your {productDetail.is_gemstone ? 'Gemstone' : 'Diamond'}
                                  </span>
                                  <div className="carat-tooltip-grade-number">
                                    {
                                      productOptions.filter(
                                        (item: any) => item.title.toLowerCase() === 'carat'
                                      )[0].value
                                    }{' '}
                                    CT
                                  </div>
                                </div>
                              </div>
                              <p className="grade-desc">
                                <small>
                                  Carat refers to the weight of a {productDetail.is_gemstone ? 'gemstone' : 'diamond'}, which is directly
                                  proportional to its size. Use the sliders to see how sizes are
                                  shown in relation to the hand.
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item color-grade-item">
                  <div
                    className="accordion-header"
                    id="diamondshape-tab2"
                  >
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Colour :{' '}
                      {
                        productOptions.filter(
                          (item: any) => item.title.toLowerCase() === 'color'
                        )[0].value
                      }
                    </button>
                  </div>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="diamondshape-tab2"
                    data-bs-parent="#shape-detail-accordian"
                  >
                    <div className="accordion-body">
                      <div className="color-grade-section">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="color-grade-detail">
                              <p>
                                A {productDetail.is_gemstone ? 'colorstone' : 'diamond'}’s colour is a key factor in determining its overall
                                quality and value. For white {productDetail.is_gemstone ? 'colorstones' : 'diamonds'}, the less colour they display,
                                the more valuable they tend to be. The Gemological Institute of
                                America (GIA) uses a standardized scale ranging from D (colourless)
                                to Z (noticeable colour) to grade {productDetail.is_gemstone ? 'colorstones' : 'diamonds'} based on the presence of
                                body colour.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="color-grade-left">
                              <div className="color-grade-img">
                                <img
                                  src={Common.setImagePath(
                                    'assets/images/tooltips/colour/colour_' +
                                      productOptions.filter(
                                        (item: any) => item.title.toLowerCase() === 'color'
                                      )[0].value +
                                      '.png'
                                  )}
                                  alt="colour"
                                />
                              </div>
                              <ul className="color-grade-list">
                                {productDetail.is_gemstone ? (
                                  <>
                                    <li
                                      data-number="Orange"
                                      data-cap="Orange"
                                      data-text={`The most chemically pure ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}. Absolutely colourless and rare. Recommended set in platinum or white gold settings.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Orange'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Orange</span>
                                    </li>
                                    <li
                                      data-number="Pink"
                                      data-cap="Pink"
                                      data-text="Earns a colourless grade because traces of colour are difficult to be detected even by trained graders. Best set in platinum or white gold settings."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Pink'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Pink</span>
                                    </li>
                                    <li
                                      data-number="Purple"
                                      data-cap="Purple"
                                      data-text={`Earns a colourless grade and best set in platinum or white gold settings. Only a trained gemmologist be able to detect any traces of colour in these ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Purple'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Purple</span>
                                    </li>
                                    <li
                                      data-number="Teal"
                                      data-cap="Teal"
                                      data-text={`${productDetail.is_gemstone ? 'Colorstones' : 'Diamonds'} of this colour offer exceptional value for money. Their colour is often unnoticeable except by trained graders.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Teal'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Teal</span>
                                    </li>
                                    <li
                                      data-number="Blue"
                                      data-cap="Blue"
                                      data-text={`${productDetail.is_gemstone ? 'Colorstones' : 'Diamonds'} of this colour offer excellent value. Their colour is only noticeable when compared to 'colourless' grade ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Blue'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Blue</span>
                                    </li>
                                    <li
                                      data-number="Green"
                                      data-cap="Green"
                                      data-text={`Upon close examination, colour may be detectable in these ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}, but still offer great value for money.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Green'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Green</span>
                                    </li>
                                    <li
                                      data-number="Yellow"
                                      data-cap="Yellow"
                                      data-text={`Upon close examination, colour may be detectable in these ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}, but still offer great value for money.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Yellow'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Yellow</span>
                                    </li>
                                    <li
                                      data-number="Red"
                                      data-cap="Red"
                                      data-text={`Upon close examination, colour may be detectable in these ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}, but still offer great value for money.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'Red'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Red</span>
                                    </li>
                                  </>
                                ) : (
                                  <>
                                    <li
                                      data-number="D"
                                      data-cap="D"
                                      data-text={`The most chemically pure ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}. Absolutely colourless and rare. Recommended set in platinum or white gold settings.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'D'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">D</span>
                                    </li>
                                    <li
                                      data-number="E"
                                      data-cap="E"
                                      data-text="Earns a colourless grade because traces of colour are difficult to be detected even by trained graders. Best set in platinum or white gold settings."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'E'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">E</span>
                                    </li>
                                    <li
                                      data-number="F"
                                      data-cap="F"
                                      data-text={`Earns a colourless grade and best set in platinum or white gold settings. Only a trained gemmologist be able to detect any traces of colour in these ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'F'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">F</span>
                                    </li>
                                    <li
                                      data-number="G"
                                      data-cap="G"
                                      data-text={`${productDetail.is_gemstone ? 'Colorstones' : 'Diamonds'} of this colour offer exceptional value for money. Their colour is often unnoticeable except by trained graders.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'G'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">G</span>
                                    </li>
                                    <li
                                      data-number="H"
                                      data-cap="H"
                                      data-text={`${productDetail.is_gemstone ? 'Colorstones' : 'Diamonds'} of this colour offer excellent value. Their colour is only noticeable when compared to 'colourless' grade diamonds. `}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'H'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">H</span>
                                    </li>
                                    <li
                                      data-number="I"
                                      data-cap="I"
                                      data-text="Upon close examination, colour may be detectable in these diamonds, but still offer great value for money."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'I'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">I</span>
                                    </li>
                                    <li
                                      data-number="J"
                                      data-cap="J"
                                      data-text="Colour may be slightly detectable even to the unaided eye, especially in larger stones."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'J'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">J</span>
                                    </li>
                                    <li
                                      data-number="K"
                                      data-cap="K"
                                      data-text="Colour may be slightly detectable even to the unaided eye, especially in larger stones."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'K'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">K</span>
                                    </li>
                                    <li
                                      data-number="L"
                                      data-cap="L"
                                      data-text="Colour may be slightly detectable even to the unaided eye, especially in larger stones."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'L'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">L</span>
                                    </li>
                                    <li
                                      data-number="M"
                                      data-cap="M"
                                      data-text="Colour may be slightly detectable even to the unaided eye, especially in larger stones."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'color'
                                        )[0].value === 'M'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">M</span>
                                    </li>
                                  </>
                                )}
                              </ul>
                              <p className="grade-desc">
                                <small>
                                  It is hidden by default, until the collapse plugin adds the
                                  appropriate classes that we use to style each element.
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item clarity-grade-item">
                  <div
                    className="accordion-header"
                    id="diamondshape-tab3"
                  >
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Clarity :{' '}
                      {
                        productOptions.filter(
                          (item: any) => item.title.toLowerCase() === 'clarity'
                        )[0].value
                      }
                    </button>
                  </div>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="diamondshape-tab3"
                    data-bs-parent="#shape-detail-accordian"
                  >
                    <div className="accordion-body">
                      <div className="clarity-grade-section">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="color-grade-detail">
                              <p>
                                Clarity refers to the presence of imperfections, flaws and blemishes
                                inside or on the surface of a {productDetail.is_gemstone ? 'colorstone' : 'diamond'}.
                              </p>
                              <p>
                                The GIA grades diamond clarity under 10X magnification on a scale
                                that ranges from Flawless (FL) to I2-3 (Included).
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="clarity-grade-left">
                              <div className="clarity-grade-img">
                                <img
                                  src={Common.setImagePath(
                                    'assets/images/tooltips/clarity/clarity_I3.png'
                                  )}
                                  alt="clarity"
                                />
                              </div>
                              <ul className="clarity-grade-list">
                                {productDetail.is_gemstone ? (
                                  <>
                                    <li
                                      data-number="gemstone_EC"
                                      data-cap="EC"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'EC'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">EC</span>
                                    </li>
                                    <li
                                      data-number="gemstone_EC1"
                                      data-cap="EC1"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'EC1'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">EC1</span>
                                    </li>
                                    <li
                                      data-number="gemstone_EC2"
                                      data-cap="EC2"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'EC2'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">EC2</span>
                                    </li>
                                    <li
                                      data-number="gemstone_SI"
                                      data-cap="SI"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'SI'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">SI</span>
                                    </li>
                                    <li
                                      data-number="gemstone_MI"
                                      data-cap="MI"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'MI'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">MI</span>
                                    </li>
                                    <li
                                      data-number="gemstone_VI1"
                                      data-cap="VI1"
                                      data-text="Slightly included 1. The inclusions are visible under 10x magnification, but are not very visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'VI1'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">VI1</span>
                                    </li>
                                    <li
                                      data-number="gemstone_VI2"
                                      data-cap="VI2"
                                      data-text="Very slightly included 2. Inclusions are difficult to detect under 10x magnification. Inclusions are typically not visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'VI2'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">VI2</span>
                                    </li>
                                  </>
                                ) : (
                                  <>
                                    <li
                                      data-number="diamond_I3"
                                      data-cap="I3"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'I3'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">I3</span>
                                    </li>
                                    <li
                                      data-number="diamond_I2"
                                      data-cap="I2"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'I2'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">I2</span>
                                    </li>
                                    <li
                                      data-number="diamond_I1"
                                      data-cap="I1"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'I1'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">I1</span>
                                    </li>
                                    <li
                                      data-number="diamond_SI3"
                                      data-cap="SI3"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'SI3'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">SI3</span>
                                    </li>
                                    <li
                                      data-number="diamond_SI2"
                                      data-cap="SI2"
                                      data-text="Slightly included 2. The inclusions are visible under 10x magnification, and may be visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'SI2'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">SI2</span>
                                    </li>
                                    <li
                                      data-number="diamond_SI1"
                                      data-cap="SI1"
                                      data-text="Slightly included 1. The inclusions are visible under 10x magnification, but are not very visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'SI1'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">SI1</span>
                                    </li>
                                    <li
                                      data-number="diamond_VS2"
                                      data-cap="VS2"
                                      data-text="Very slightly included 2. Inclusions are difficult to detect under 10x magnification. Inclusions are typically not visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'VS2'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">VS2</span>
                                    </li>
                                    <li
                                      data-number="diamond_VS1"
                                      data-cap="VS1"
                                      data-text="Very slightly included 1. Inclusions are difficult to detect under 10x magnification. Inclusions are not visible to the naked eye."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'VS1'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">VS1</span>
                                    </li>
                                    <li
                                      data-number="diamond_VVS2"
                                      data-cap="VVS2"
                                      data-text={`Very very slightly included 2. The inclusions are difficult to see even under 10x magnification. They have only slightly more inclusions than VVS1 ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'}.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'VVS2'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">VVS2</span>
                                    </li>
                                    <li
                                      data-number="diamond_VVS1"
                                      data-cap="VVS1"
                                      data-text="Very very slightly included 1. The inclusions are difficult to see even under 10x magnification."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'VVS1'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">VVS1</span>
                                    </li>
                                    <li
                                      data-number="diamond_IF"
                                      data-cap="IF"
                                      data-text={`Internally Flawless. These rare and beautiful ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'} boast no internal flaws.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'IF'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">IF</span>
                                    </li>
                                    <li
                                      data-number="diamond_FL"
                                      data-cap="FL"
                                      data-text={`Flawless. The ultimate in ${productDetail.is_gemstone ? 'colorstone' : 'diamond'} clarity, completely free of internal or external flaws.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions.filter(
                                          (item: any) => item.title.toLowerCase() === 'clarity'
                                        )[0].value === 'FL'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">FL</span>
                                    </li>
                                  </>
                                )}
                              </ul>
                              <p className="grade-desc">
                                <small>
                                  Included 1. Some inclusions could be visible to the naked eye.
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {productOptions !== undefined &&
                  productOptions.filter((x: any) => x.title === 'Shape')[0]?.value.toLowerCase() ===
                    'round' && (
                    <div className="accordion-item cut-grade-item">
                      <div
                        className="accordion-header"
                        id="diamondshape-tab4"
                      >
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Cut :{' '}
                          {
                            productOptions.filter(
                              (item: any) => item.title.toLowerCase() === 'cut'
                            )[0].value
                          }
                        </button>
                      </div>
                      <div
                        id="collapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="diamondshape-tab4"
                        data-bs-parent="#shape-detail-accordian"
                      >
                        <div className="accordion-body">
                          <div className="cut-grade-section">
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="color-grade-detail">
                                  <p>
                                    The cut of a {productDetail.is_gemstone ? 'colorstone' : 'diamond'} influences how effectively it reflects
                                    light. Well-cut {productDetail.is_gemstone ? 'colorstones' : 'diamonds'} appear fiery and brilliant and allow
                                    light to enter the stone and be reflected around the facets
                                    before exiting the stone through the top. Poorly-cut {productDetail.is_gemstone ? 'colorstones' : 'diamonds'}
                                    can appear lifeless and dark, despite their clarity or color
                                    grade.
                                  </p>
                                  <p>
                                    Not only do well-cut {productDetail.is_gemstone ? 'colorstones' : 'diamonds'} appear more brilliant, they also
                                    tend to appear larger than other {productDetail.is_gemstone ? 'colorstones' : 'diamonds'} of the same carat
                                    weight.
                                  </p>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="cut-grade-left">
                                  <div className="cut-grade-img">
                                    <img
                                      src={Common.setImagePath(
                                        'assets/images/tooltips/cut/cut_Excellent.png'
                                      )}
                                      alt="cut"
                                    />
                                  </div>
                                  <ul className="cut-grade-list">
                                    <li
                                      data-number="Ideal"
                                      data-cap="Ideal"
                                      data-text={`Superior quality cut that produces a striking balance of fire and brilliance. Only 3% of the world’s ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'} are ideal cut.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions
                                          .filter(
                                            (item: any) => item.title.toLowerCase() === 'cut'
                                          )[0]
                                          .value?.toLowerCase() === 'ideal'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Ideal</span>
                                    </li>
                                    <li
                                      data-number="Excellent"
                                      data-cap="Excellent"
                                      data-text={`Superior quality cut that produces a striking balance of fire and brilliance. Only 3% of the world’s ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'} are ideal cut.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions
                                          .filter(
                                            (item: any) => item.title.toLowerCase() === 'cut'
                                          )[0]
                                          .value?.toLowerCase() === 'excellent'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Excellent</span>
                                    </li>
                                    <li
                                      data-number="Very_Good"
                                      data-cap="Very Good"
                                      data-text={`High quality cut that reflects almost as much light as an ideal cut ${productDetail.is_gemstone ? 'colorstone' : 'diamond'}, yet at a more affordable price.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions
                                          .filter(
                                            (item: any) => item.title.toLowerCase() === 'cut'
                                          )[0]
                                          .value?.toLowerCase() === 'very good'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Very Good</span>
                                    </li>
                                    <li
                                      data-number="Good"
                                      data-cap="Good"
                                      data-text={`High quality cut that reflects almost as much light as an ideal cut ${productDetail.is_gemstone ? 'colorstone' : 'diamond'}, yet at a more affordable price.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions
                                          .filter(
                                            (item: any) => item.title.toLowerCase() === 'cut'
                                          )[0]
                                          .value?.toLowerCase() === 'good'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Good</span>
                                    </li>
                                    <li
                                      data-number="Fair"
                                      data-cap="Fair"
                                      data-text={`Superior quality cut that produces a striking balance of fire and brilliance. Only 3% of the world’s ${productDetail.is_gemstone ? 'colorstones' : 'diamonds'} are ideal cut.`}
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions
                                          .filter(
                                            (item: any) => item.title.toLowerCase() === 'cut'
                                          )[0]
                                          .value?.toLowerCase() === 'fair'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Fair</span>
                                    </li>
                                    <li
                                      data-number="Poor"
                                      data-cap="Poor"
                                      data-text="Quality cut at a great value, without compromising beauty and sparkle."
                                      className={
                                        'grade-list-btn ' +
                                        (productOptions
                                          .filter(
                                            (item: any) => item.title.toLowerCase() === 'cut'
                                          )[0]
                                          .value?.toLowerCase() === 'poor'
                                          ? 'active'
                                          : '')
                                      }
                                    >
                                      <span className="grade-list-label">Poor</span>
                                    </li>
                                  </ul>
                                  <p className="grade-desc">
                                    <small>
                                      Quality cut at a great value, without compromising beauty and
                                      sparkle.
                                    </small>
                                    s
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiamondDetailSummry
